import React from 'react';
import { IAdresse } from '../types';
import { VirksomhetAdresseView } from './VirksomhetAdresseView';
interface IVirksomhetAdresseInfoProps {
  beliggenhetsadresse?: IAdresse;
  postadresse?: IAdresse;
}
export const VirksomhetAdresseInfo = ({
  beliggenhetsadresse,
  postadresse
}: IVirksomhetAdresseInfoProps) => <div className="virksomhet-adresse-info" data-sentry-component="VirksomhetAdresseInfo" data-sentry-source-file="VirksomhetAdresseInfo.tsx">
    <VirksomhetAdresseView adresse={beliggenhetsadresse} tittel="Beliggenhetsadresse" data-sentry-element="VirksomhetAdresseView" data-sentry-source-file="VirksomhetAdresseInfo.tsx" />
    <VirksomhetAdresseView adresse={postadresse} tittel="Postadresse" data-sentry-element="VirksomhetAdresseView" data-sentry-source-file="VirksomhetAdresseInfo.tsx" />
  </div>;